import React, { useState, useEffect, useRef } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import "./UserProfile.css";
import { CgLogOff } from "react-icons/cg";
import { BsCalendarCheck } from "react-icons/bs";
import Header from "../Header/Header";
import { BsPersonCircle } from "react-icons/bs";
import axiosConfig from "../../Service/AxiosConfig";
import { CgProfile } from "react-icons/cg";
import { clearTempForm } from "../../redux/BookingFormSlice";
import { persistor } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { clearDocumentsDB } from "../../utils/indexedDB";
import { clearProfile, setProfile } from "../../redux/ProfileSlice";
import { useAuth } from "../../Context/AuthContext";
import { FaTimes } from "react-icons/fa";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { HiMenuAlt2 } from "react-icons/hi";
import { PopupModal } from "../../PopupModal/PopupModal";
import loader from "../../Animations/Sandy Loading.gif";
const UserProfile = () => {
  const navigate = useNavigate();
  const [activeUrl, setActiveUrl] = useState("");
  const [selfieImage, setSelfieImage] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const fileInputRef = useRef(null);
  const { logout, user } = useAuth();
  const dispatch = useDispatch();
  const profileName = useSelector((state) => state.profile.profile?.name || "");
  const [showEditOptions, setShowEditOptions] = useState(false);
  const [isMobileProfileMenuOpen, setIsMobileProfileMenuOpen] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [profileLoading, setProfileLoading] = useState(true);
  const displayName =
    profileName.trim() ||
    user?.name?.trim() ||
    `+91${user?.mobileno || ""}`;

  const handleLogout = async () => {
    await clearDocumentsDB();
    dispatch(clearTempForm());
    dispatch(clearProfile());
    persistor.purge();
    localStorage.removeItem("persist:bookingForm");
    localStorage.removeItem("persist:profile");
    localStorage.removeItem("mobileno");
    logout();
    navigate("/");
  };

  const handleNavigate = (url) => {
    navigate(url);
    setIsMobileProfileMenuOpen(false);
  };

  useEffect(() => {
    setActiveUrl(window.location.pathname);
  }, [window.location.pathname]);

  let user_id = user?.id;

  const fetchUserProfile = async () => {
    if (!user_id) return;

    try {
      setProfileLoading(true);

      const response = await axiosConfig.get(
        `/provider-data/providers/?user=${user_id}`,
      );

      const data = response?.data?.results?.[0];
      dispatch(
        setProfile({
          name: data?.user?.name || "",
          mobileno: data?.user?.mobileno || "",
          profile: data?.user?.profile || null,
        }),
      );
      setSelfieImage(data?.user?.profile || null);
    } catch (error) {
      console.log("Error fetching profile:", error);
    } finally {
      setProfileLoading(false);
    }
  };

  useEffect(() => {
    if (user_id) {
      fetchUserProfile();
    }
  }, [user_id]);

  const handleFileChange = async (e) => {
    setError("");
    setMessage("");
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("profile", file);
    try {
      const uploadResponse = await axiosConfig.patch(
        `/accounts/profile_update/${user_id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      setSelfieImage((prev) => ({
        ...prev,
        profile: uploadResponse?.data?.profile,
      }));
      setPopupType("success");
      setShowModal(false);
      setMessage(
        uploadResponse?.data?.message || "Profile updated successfully!",
      );
      setError("");
      fetchUserProfile();
    } catch (error) {
      console.log("Upload error:", error);
      setPopupType("error");
      setError(error?.response?.data?.error || "Something went wrong");
      setShowModal(false);
    }
  };
  console.log(selfieImage, "selfieImage");
  const toggleMobileProfileMenu = () => {
    setIsMobileProfileMenuOpen(!isMobileProfileMenuOpen);
  };

  return (
    <>
      <Header />
      <div className="content-1 patient-dashboard-parent">
        <button
          className="mobile-profile-menu-btn"
          onClick={toggleMobileProfileMenu}
        >
          {isMobileProfileMenuOpen ? (
            <FaTimes size={24} />
          ) : (
            <HiMenuAlt2 size={24} />
          )}
        </button>
        <div
          className={`patient-dashboard desktop ${
            isMobileProfileMenuOpen ? "open" : ""
          }`}
        >
          <div className="big-img-content">
            {/* {selfieImage ? (
              <img
                src={selfieImage}
                alt="Profile"
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
              />
            ) : (
              <BsPersonCircle
                size={40}
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
                style={{ cursor: "pointer" }}
              />
            )} */}
            {profileLoading ? (
              <div className="loader-wrapper">
                <img src={loader} alt="Loading..." />
              </div>
            ) : selfieImage ? (
              <img
                src={selfieImage}
                alt="Profile"
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
              />
            ) : (
              <BsPersonCircle
                size={40}
                className="profile-div-img"
                onClick={() => setShowEditOptions(true)}
                style={{ cursor: "pointer" }}
              />
            )}

            <span style={{ color: "#000" }} className="mt-3">
              {displayName}
            </span>
            {showEditOptions && (
              <button
                className="profile-edit"
                onClick={() => {
                  setShowEditOptions(false);
                  setShowModal(true);
                }}
              >
                Edit
              </button>
            )}
          </div>

          <div
            className={`dashboard-item ${
              activeUrl === "/user-profile/profile" ? "active" : ""
            }`}
            onClick={() => handleNavigate("/user-profile/profile")}
          >
            <CgProfile size={16} />
            <span>Profile</span>
          </div>

          <div
            className={`dashboard-item ${
              activeUrl.startsWith("/user-profile/my-bookings") ? "active" : ""
            }`}
            // onClick={() => handleNavigate("/user-profile/my-bookings")}
          >
            <BsCalendarCheck size={16} />
            <span>My Bookings</span>
          </div>
          <div className="dashboard-item logout" onClick={handleLogout}>
            <CgLogOff size={16} />
            <span>Logout</span>
          </div>
        </div>
        <Outlet />
      </div>
      {showModal && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Choose Option</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ textAlign: "center" }}>
            <Button
              variant="secondary"
              className="mb-2"
              onClick={() => fileInputRef.current.click()}
              style={{ width: "100%" }}
            >
              📤 Upload From Gallery
            </Button>
            <input
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              id="cameraInput"
              onChange={handleFileChange}
            />

            <Button
              variant="success"
              className="mb-2"
              onClick={() => document.getElementById("cameraInput").click()}
              style={{ width: "100%" }}
            >
              📷 Take Photo (Camera)
            </Button>
            <Button
              onClick={() => fileInputRef.current.click()}
              style={{ width: "100%" }}
            >
              📁 Upload From Drive
            </Button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/*"
              style={{ display: "none" }}
            />
          </Modal.Body>
        </Modal>
      )}
      {popupType && (
        <PopupModal
          setpopupType={setPopupType}
          popupType={popupType}
          Navigation=""
          error={error}
          Message={message}
          setMessage={setMessage}
        />
      )}
    </>
  );
};

export { UserProfile };
